const newsRouter = {
  route: null,
  name: null,
  title: '资讯中心',
  type: 'folder', // 类型: folder, tab, view
  icon: 'iconfont el-icon-news',
  filePath: 'view/news/', // 文件路径
  order: 30,
  inNav: true,
  permission: ['政策资讯列表'],
  children: [
    {
      title: '政策资讯',
      type: 'folder', // 取 route 为默认加载页
      icon: 'iconfont el-icon-chat-line-round',
      isElementIcon: false,
      filePath: 'view/news/policy_news/',
      inNav: true,
      permission: ['政策资讯列表'],
      name: null,
      children: [
        {
          title: '政策资讯列表',
          type: 'view',
          name: 'policyNewsList',
          route: '/news/policyNews/list',
          filePath: 'view/news/policy_news/list.vue',
          inNav: true,
          icon: 'iconfont el-icon-notebook-2',
          permission: ['政策资讯列表'],
        },
        {
          title: '新增政策资讯',
          type: 'view',
          name: 'addPolicyNews',
          route: '/news/policyNews/add',
          filePath: 'view/news/policy_news/create.vue',
          inNav: true,
          icon: 'iconfont el-icon-document-add',
          permission: ['新增政策资讯'],
        },
      ],
    },
    {
      title: '办事指南',
      type: 'folder', // 取 route 为默认加载页
      icon: 'iconfont el-icon-chat-dot-round',
      isElementIcon: false,
      filePath: 'view/news/service_guides/',
      inNav: true,
      name: null,
      children: [
        {
          title: '办事指南列表',
          type: 'view',
          name: 'serviceGuidesList',
          route: '/serviceGuides/list',
          filePath: 'view/news/service_guides/list.vue',
          inNav: true,
          icon: 'iconfont el-icon-notebook-2',
          permission: ['办事指南列表'],
        },
        {
          title: '新增办事指南',
          type: 'view',
          name: 'addServiceGuides',
          route: '/serviceGuides/add',
          filePath: 'view/news/service_guides/create.vue',
          inNav: true,
          icon: 'iconfont el-icon-document-add',
          permission: ['新增办事指南'],
        },
      ],
    },
  ],
}

export default newsRouter
